import { connectedStore } from '../../store';
import view from '../../view';
import getSelection from '../../hdrm/accessors/get-selection';

const setSelectionOnInput = () => {
  const store = connectedStore.get();

  const focusedElementId = view.selectors.getFocusedElement(store.getState());
  if (!focusedElementId) return;

  const selection = getSelection();

  store.dispatch(view.actions.setSelection(selection));
};

export default setSelectionOnInput;
